import React from 'react';
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { useFieldConfiguration } from '../../../Hooks/Features/TaskLayout/Fields/useFieldConfiguration';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import FieldConfigurationDetails from './FieldConfigurationDetails';
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';
import _ from "underscore";

const FieldConfiguration = ({ filterValues, setFilterValues }) => {
    const { columns, rowData, visible, setVisible, fieldValues, setFieldValues, handleChange, formJson, upsertFieldConfig, loader } = useFieldConfiguration({ filterValues, setFilterValues })

    return (
        <div className="">
            {
                !_.isEmpty(filterValues?.config) ? <FieldConfigurationDetails filterValues={filterValues} setFilterValues={setFilterValues} fieldValues={fieldValues} setFieldValues={setFieldValues} upsertFieldConfig={upsertFieldConfig} /> : <>
                    <div className=" d-flex align-items-center justify-content-between">
                        <input
                            type="text"
                            placeholder="Search configurations..."
                            className="sk-input-dd w85"
                            value={filterValues?.search}
                            onChange={(e) => setFilterValues((prev) => ({ ...prev, search: e.target.value }))}
                        />

                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="sk-btn text-white bg-black sk-btn-primary"
                                onClick={() => { setVisible({ show: true }); }}
                            >
                                <FontAwesomeIcon icon="fa-solid fa-plus" /> Configuration
                            </button>
                        </div>
                    </div>
                    <div className="mt-2 w100" style={{ height: "calc(100vh - 160px)", overflow: "auto" }}>
                        <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} expandAll={true} headerHeight={50} strippedTable={true} loader={loader?.grid} />
                    </div>
                </>
            }

            <Dialog
                draggable={false}
                header="Create Field configuration"
                visible={visible?.show}
                onHide={() => { setVisible({ show: false }); setFieldValues({}) }}
                className='modal-xsmall'>
                <div>
                    <div className='row'>
                        {
                            formJson?.map((item, index) => (
                                renderField(item, index, (e) => { handleChange(item, e) }, fieldValues, {}, {
                                    is_edit: item?.textField, fromProject: 0
                                }, () => { }, () => { })
                            ))
                        }
                    </div>
                    <div className='d-flex gap-2 align-items-center justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => { setVisible({ show: false }); setFieldValues({}) }}>Cancel</button>
                        {
                            loader?.btn ? <button className="sk-btn text-white bg-black sk-btn-primary" style={{ width: "65px", height: "30px" }}>
                                <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> : <button className='sk-btn text-white bg-black sk-btn-primary' onClick={() => upsertFieldConfig()} >Submit</button>
                        }

                    </div>
                </div>
            </Dialog>
            <CommanDialog
                visible={visible?.delete}
                message={"Are You Sure You Want to delete it?"}
                handleClose={() => { setVisible((prev) => ({ ...prev, delete: false })) }}
                handleFun={() => {
                    upsertFieldConfig(true)
                }}
                loader={loader?.btn}
            />
        </div>
    );
};

export default FieldConfiguration;